module.exports = __webpack_public_path__ + "static/media/stirfry.2430155f.jpg";